import React from 'react';
import { Fragment } from 'react';
import { RecommendedFollowsShape, UserShape } from '../shapes';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import RecommendedUserToFollow from './recommended_user_to_follow';
import Waiting from './waiting';

export default class FollowRecommendationsFirstRun extends React.Component {

  static propTypes = {
    user: UserShape,
    recommendedFollows: RecommendedFollowsShape,
    onFollow: PropTypes.func,
    onUnFollow: PropTypes.func,
    onReset: PropTypes.func,
    onLoadRecommendedFollows: PropTypes.func,
  }

  componentDidMount() {
    this.props.onReset();
    this.props.onLoadRecommendedFollows();
  }

  render() {
    let followRecommendationContent = null;
      if (this.props.recommendedFollows.get('loading')) {
      followRecommendationContent = this.renderLoading.bind(this);
    } else {
      followRecommendationContent = this.renderRecommendedUsersToFollow.bind(this);
    }
    return (
      <div className='follow-rows'>
        <div className='heading'>
          <h2>Last, follow a couple of people.</h2>
          <p>
            One of the best things about Yak Tack is following people to discover new words.
            Here are a few people we recommend.
          </p>
        </div>
        { followRecommendationContent() }
      </div>
    )
  }

  renderRecommendedUsersToFollow() {
    const recommendedUsersToFollow = this.props.recommendedFollows.get('recommendedUsers').map((recommendedUserToFollow, i) => {
      return (
        <li key={ i } className='list-group-item'>
          <RecommendedUserToFollow onFollow={ this.props.onFollow } onUnFollow={ this.props.onUnFollow } recommendedUserToFollow={ recommendedUserToFollow } />
        </li>
      );
    });

    return (
      <Fragment>
        <div className='follow-recommendations-group'>
          <ul className='list-group'>{ recommendedUsersToFollow }</ul>
        </div>
        <div className='action'>
          <Link to='/account/recommend_people_to_follow_first_run_congrats' className='btn btn-dark'>Done!</Link>
        </div>
      </Fragment>
    );
  }

  renderLoading() {
    return(
      <Waiting />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/follow_recommendations_first_run.jsx